var render = function () {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "rb-fieldrow": true,
        "rb-emptyrow": _vm.isEmptyRow,
        "rb-floating": _vm.isFloating,
        "rb-validrow": _vm.isValidRow,
        "rb-invalidrow": _vm.isInValidRow,
        "rb-fieldrow__with-icon": _vm.icon,
      },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model.trim.lazy",
            value: _vm.value,
            expression: "value",
            modifiers: { trim: true, lazy: true },
          },
        ],
        ref: "field",
        attrs: {
          id: _vm.id,
          "aria-label": _vm.inputAriaLabel,
          type: _vm.type,
          name: _vm.name,
          placeholder: _vm.placeholder,
          required: _vm.required,
          pattern: _vm.pattern,
          minlength: _vm.minlength,
          maxlength: _vm.maxlength,
          disabled: _vm.disabled,
          autocomplete: _vm.autocomplete,
        },
        domProps: { value: _vm.value },
        on: {
          focusin: _vm.onFocusIn,
          focusout: _vm.onFocusOut,
          change: function ($event) {
            _vm.value = $event.target.value.trim()
          },
          blur: function ($event) {
            return _vm.$forceUpdate()
          },
        },
      }),
      _vm._v(" "),
      _vm.label
        ? _c(
            "label",
            {
              class: { "rb-field--required": _vm.required },
              attrs: { for: _vm.id },
              on: {
                click: function ($event) {
                  return _vm.focus()
                },
              },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.label) + "\n    "),
              !_vm.required && _vm.labelOptional
                ? _c("span", { staticClass: "rb-field--optional" }, [
                    _vm._v(" " + _vm._s(_vm.labelOptional)),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.helper
        ? _c("span", { staticClass: "rb-fieldrow__helper" }, [
            _vm._v(_vm._s(_vm.helper)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error && _vm.isInValidRow
        ? _c("span", { staticClass: "rb-fieldrow__helper" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.helperError && _vm.isInValidRow
        ? _c(
            "span",
            { staticClass: "rb-fieldrow__helper rb-fieldrow__helper--error" },
            [_vm._v(_vm._s(_vm.helperError))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isIcon
        ? _c("span", {
            class:
              ((_obj = { "rb-fieldrow__end-icon": true }),
              (_obj[_vm.icon] = _vm.icon),
              _obj),
            attrs: { "aria-hidden": "true" },
            on: { click: _vm.onIconClick },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "password"
        ? _c("div", {
            staticClass: "rb-fieldrow__end-icon",
            class: ((_obj$1 = {}), (_obj$1[_vm.icon] = _vm.icon), _obj$1),
            attrs: { disabled: _vm.disabled },
            on: { click: _vm.togglePassword },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }